import { io } from "socket.io-client";
import { backendUrl } from "../Router/constant";

const getSocketOrigin = () => {
  return new URL(
    backendUrl,
    window.location.origin,
  ).origin;
};

const cleanAuthToken = (token = "") => {
  return String(token)
    .replace(/^Bearer\s+/i, "")
    .trim();
};

const resolveInquiryId = (value) => {
  if (!value || typeof value !== "object") {
    return String(value || "").trim();
  }

  const nestedInquiry =
    value.inquiry && typeof value.inquiry === "object"
      ? value.inquiry
      : value.inquiryId && typeof value.inquiryId === "object"
        ? value.inquiryId
        : null;
  const isChatRecord = Boolean(
    value.chatType ||
      value.lastMessage ||
      value.latestMessage ||
      value.messages ||
      value.displayInquiryId,
  );
  const candidate =
    value.inquiryMongoId ||
    nestedInquiry?._id ||
    value.inquiry?._id ||
    value.inquiry_id?._id ||
    (value._id && !isChatRecord ? value._id : "") ||
    (typeof value.inquiryId === "string" ? value.inquiryId : "");

  return String(candidate || "").trim();
};

const createChatSocket = (token) => {
  const cleanToken =
    cleanAuthToken(token);

  const socket = io(
    getSocketOrigin(),
    {
      auth: {
        token: cleanToken,
      },

      autoConnect: false,

      reconnection: true,
      reconnectionAttempts: Infinity,
      reconnectionDelay: 1000,

      timeout: 15000,
    },
  );

  return socket;
};

const joinInquiryRoom = (
  socket,
  inquiry,
  callback,
) => {
  const inquiryId = resolveInquiryId(inquiry);
  if (!inquiryId) {
    callback?.({
      ok: false,
      message: "A valid inquiry ID is required.",
    });
    return;
  }

  if (!socket) {
    callback?.({
      ok: false,
      message:
        "Socket is not available.",
    });

    return;
  }

  socket
    .timeout(15000)
    .emit(
      "join_inquiry",
      {
        inquiryId:
          String(inquiryId),

        chatType:
          "admin_vendor",
      },
      (
        error,
        response,
      ) => {
        if (error) {
          callback?.({
            ok: false,
            message:
              "Joining this conversation timed out.",
          });

          return;
        }

        callback?.(
          response,
        );
      },
    );
};

const sendInquiryMessage = (
  socket,
  inquiry,
  message,
  callback,
) => {
  const inquiryId = resolveInquiryId(inquiry);
  if (!inquiryId) {
    callback?.({
      ok: false,
      message: "A valid inquiry ID is required.",
    });
    return;
  }

  if (!socket?.connected) {
    callback?.({
      ok: false,
      message:
        "Socket is not connected.",
    });

    return;
  }

  socket
    .timeout(15000)
    .emit(
      "send_inquiry_message",
      {
        inquiryId:
          String(inquiryId),

        message,

        chatType:
          "admin_vendor",
      },
      (
        error,
        response,
      ) => {
        if (error) {
          callback?.({
            ok: false,
            message:
              "Message confirmation timed out.",
          });

          return;
        }

        callback?.(
          response,
        );
      },
    );
};

const disconnectChatSocket = (
  socket,
) => {
  if (!socket) {
    return;
  }

  socket.removeAllListeners();

  if (socket.connected) {
    socket.disconnect();
  }
};

const chatSocketService = {
  createChatSocket,
  joinInquiryRoom,
  sendInquiryMessage,
  disconnectChatSocket,
};

export default chatSocketService;
